import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedancabsbookinginpune() {



const cardData =
  {
    keyword: 'Sedan Cabs Booking in Pune',
    heading: 'Sanavi Travels: Sedan Cabs Booking in Pune',
    headingDescription: 'Sanavi Travels offers trusted, comfortable, and affordable Sedan Cabs Booking in Pune for individuals, families, corporate professionals, and tourists who prefer smooth, private, and reliable travel. Sedan cabs are among the most popular choices in Pune due to their balanced combination of comfort, elegance, fuel efficiency, and suitability for both city and highway journeys. Whether you require a sedan cab for airport transfers, railway station pickups, corporate meetings, wedding functions, local sightseeing, family outings, or long-distance outstation travel, Sanavi Travels ensures a seamless experience with well-maintained vehicles and professional chauffeurs. Our sedan fleet includes premium and economical options with AC and Non-AC variants, offering comfortable seating, ample boot space for luggage, and a quiet cabin that reduces travel fatigue. Sedan cabs are ideal for navigating Pune’s busy city roads while also delivering stable performance on highways connecting Mumbai, Lonavala, Nashik, Shirdi, Mahabaleshwar, Kolhapur, and other destinations. With transparent pricing, no hidden charges, flexible booking options, punctual pickups, courteous drivers, and 24/7 customer support, Sanavi Travels delivers a stress-free and dependable sedan cab rental experience in Pune, perfectly suited for daily travel as well as special occasions.',

    top: 'Popular Travel Uses for Sedan Cabs Booking in Pune',


"topPlaces": [
  {
    "title": "Sedan Cab for Airport Transfers in Pune",
    "description": "Sedan cabs are one of the most preferred options for Pune airport pickups and drops due to their comfortable seating, smooth ride quality, and sufficient boot space for luggage. Travelers appreciate the ease with which sedan cars navigate city traffic while ensuring timely arrivals at the airport. For early morning flights, late-night landings, and corporate airport transfers, sedan cabs provide reliability, punctuality, and a relaxed travel experience for solo travelers, couples, and small families."
  },
  {
    "title": "Sedan Cab for Railway Station Pickup and Drop",
    "description": "Passengers traveling to and from Pune railway stations frequently choose sedan cabs for their convenience and affordability. Sedan cars offer smooth city driving, easy boarding, and adequate luggage space, making them ideal for families, senior citizens, and business travelers who want stress-free railway station transfers without delays."
  },
  {
    "title": "Outstation Travel from Pune by Sedan",
    "description": "Sedan cabs are highly suitable for outstation journeys from Pune to destinations such as Mumbai, Lonavala, Lavasa, Shirdi, Nashik, Mahabaleshwar, Satara, Kolhapur, Aurangabad, and beyond. Their fuel efficiency, stable handling, and comfortable suspension make sedan cars a cost-effective and pleasant option for long-distance travel. Couples and small families often prefer sedans for weekend getaways and holiday trips."
  },
  {
    "title": "Wedding and Family Function Travel",
    "description": "For weddings and family events, sedan cabs are commonly used for transporting relatives, guests, and family members between homes, venues, and hotels. The elegant appearance of sedan cars, combined with clean interiors and smooth rides, makes them suitable for special occasions where comfort and presentation are important."
  },
  {
    "title": "Corporate Travel in Pune",
    "description": "Corporate professionals rely on sedan cabs for office travel, meetings, conferences, client visits, and daily business commutes. The professional look, quiet cabin, and comfortable seating of sedan cars create a productive and relaxed environment for business travel across Pune and nearby industrial areas."
  },
  {
    "title": "Local Sightseeing in Pune",
    "description": "Tourists and families exploring Pune often book sedan cabs for local sightseeing trips. Sedan cars provide comfort throughout the day, even during multiple stops, traffic conditions, and extended city tours covering temples, historical landmarks, shopping areas, and nearby attractions."
  },
  {
    "title": "Family Trips and Personal Travel",
    "description": "Sedan cabs are ideal for small family trips, personal outings, shopping visits, and casual travel within Pune. Their comfortable seating, smooth ride, and easy accessibility make them suitable for passengers of all age groups, including elders and children."
  },
  {
    "title": "Highway and Expressway Travel",
    "description": "With stable handling and refined driving performance, sedan cars perform well on highways and expressways connecting Pune to major cities. Travelers appreciate the balance of comfort and efficiency offered by sedan cabs during long highway drives."
  },
  {
    "title": "One-Day and Multi-Day Sedan Rentals",
    "description": "Sedan cabs can be booked for single-day local usage or multi-day travel plans, offering flexibility for travelers with varying itineraries. This makes them suitable for both short-term requirements and extended journeys."
  },
  {
    "title": "Affordable Daily Cab Usage in Pune",
    "description": "Due to economical pricing and good mileage, sedan cabs are widely used for daily travel needs in Pune, providing a budget-friendly yet comfortable transportation solution."
  }
]
,



"services": [
{
"name": "Sedan Cabs Booking in Pune",
"description": "Sedan Cabs Booking in Pune provides a reliable, comfortable, and economical travel solution for individuals, families, and corporate travelers. Sedan cars are ideal for city commutes, airport transfers, railway station drops, weddings, corporate travel, local sightseeing, and outstation journeys. Sanavi Travels ensures clean and well-maintained sedan vehicles, professional drivers, transparent pricing, and punctual service, delivering a hassle-free cab booking experience every time."
},
{
"name": "Sedan Taxi Hire Pune",
"description": "Sedan Taxi Hire Pune offers flexible rental options for local travel, business trips, personal usage, and long-distance journeys. This service is popular among customers who prefer privacy, comfort, and dependable transportation with trained chauffeurs."
},
{
"name": "AC Sedan Cab Pune",
"description": "AC Sedan Cab Pune ensures a cool and comfortable travel experience, especially during hot weather and long journeys. Air-conditioned sedan cabs are ideal for premium yet affordable travel across Pune and nearby destinations."
},
{
"name": "Non AC Sedan Cab Pune",
"description": "Non AC Sedan Cab Pune is a budget-friendly option for short-distance and economical travel, offering the same safety, comfort, and reliability at a lower cost."
},
{
"name": "Sedan Cab for Airport Transfer Pune",
"description": "Sedan Cab for Airport Transfer Pune guarantees timely pickups, smooth rides, and sufficient luggage space, making airport travel easy and stress-free for passengers."
},
{
"name": "Sedan Cab for Railway Pickup Pune",
"description": "Sedan Cab for Railway Pickup Pune ensures on-time station transfers with comfortable seating and smooth navigation through city traffic."
},
{
"name": "Sedan Cab for Wedding Pune",
"description": "Sedan Cab for Wedding Pune is suitable for transporting wedding guests, family members, and relatives comfortably during wedding functions and ceremonies."
},
{
"name": "Sedan Cab for Corporate Travel Pune",
"description": "Sedan Cab for Corporate Travel Pune supports professional business travel, meetings, conferences, and office commutes with a refined and punctual service."
},
{
"name": "Sedan Cab for Outstation Pune",
"description": "Sedan Cab for Outstation Pune provides dependable long-distance travel with experienced drivers, good mileage, and comfortable seating for extended journeys."
},
{
"name": "Affordable Sedan Cab Hire Pune",
"description": "Affordable Sedan Cab Hire Pune delivers cost-effective sedan travel solutions without compromising on vehicle quality or service standards."
},
{
"name": "Best Sedan Cab Service Pune",
"description": "Best Sedan Cab Service Pune by Sanavi Travels is trusted for reliability, transparent pricing, courteous drivers, and consistent customer satisfaction."
},
{
"name": "Sedan Cab with Driver Pune",
"description": "Sedan Cab with Driver Pune includes trained chauffeurs who manage traffic, routes, and schedules, allowing passengers to enjoy a relaxed journey."
},
{
"name": "Sedan Cab for Local Sightseeing Pune",
"description": "Sedan Cab for Local Sightseeing Pune enables tourists and families to explore Pune comfortably throughout the day, even with multiple stops."
},
{
"name": "Sedan Cab for Family Trip Pune",
"description": "Sedan Cab for Family Trip Pune is ideal for small family outings and vacations, offering comfort, safety, and affordability."
},
{
"name": "Luxury Sedan Cab Hire Pune",
"description": "Luxury Sedan Cab Hire Pune provides a premium sedan travel experience with well-maintained vehicles and professional drivers for special occasions."
}
],
"tableData": [
["Sedan Cabs Booking in Pune", "Sedan Taxi Hire Pune"],
["AC Sedan Cab Pune", "Non AC Sedan Cab Pune"],
["Sedan Airport Cab Pune", "Sedan Railway Pickup Pune"],
["Sedan Wedding Cab Pune", "Sedan Corporate Cab Pune"],
["Sedan Outstation Cab Pune", "Sedan Family Trip Pune"],
["Affordable Sedan Cab Pune", "Best Sedan Cab Service Pune"],
["Luxury Sedan Cab Pune", "Sedan Cab with Driver Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Sedan Cabs Booking in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable sedan cab services across Pune for all travel requirements."
  },
  {
    "WhyChooseheading": "Comfortable and Elegant Vehicles",
    "WhyChoosedescription": "Sedan cars provide smooth rides, quiet cabins, and comfortable seating for city and highway travel."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our trained chauffeurs ensure safe driving, punctual service, and excellent route knowledge."
  },
  {
    "WhyChooseheading": "Transparent Pricing Policy",
    "WhyChoosedescription": "Clear and upfront pricing with no hidden charges ensures complete peace of mind."
  },
  {
    "WhyChooseheading": "Multiple Travel Needs Covered",
    "WhyChoosedescription": "Suitable for airport, railway, wedding, corporate, sightseeing, and outstation travel."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Sedan Cars",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip for passenger safety."
  },
  {
    "WhyChooseheading": "24/7 Booking and Customer Support",
    "WhyChoosedescription": "Round-the-clock assistance for bookings, queries, and travel support."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "Guaranteed punctual pickups and smooth journey execution every time."
  }
]

}

const faqData = [
  {
    question: 'Do you provide sedan cabs booking in Pune?',
    answer: 'Yes, Sanavi Travels offers sedan cabs booking across Pune for various travel needs.'
  },
  {
    question: 'Are AC and Non-AC sedan cabs available?',
    answer: 'Yes, both AC and Non-AC sedan cabs are available.'
  },
  {
    question: 'Can I book a sedan cab for outstation travel?',
    answer: 'Yes, sedan cabs can be booked for outstation and long-distance journeys.'
  },
  {
    question: 'Is driver included in sedan cab booking?',
    answer: 'Yes, all sedan cab bookings include experienced drivers.'
  },
  {
    question: 'Is sedan suitable for family travel?',
    answer: 'Yes, sedan cabs are ideal for small family trips and comfortable travel.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Booked a sedan cab in Pune for airport travel. Very smooth ride and punctual service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Poonam Desai',
    feedback: 'Excellent sedan cab service for our family outing. Clean car and polite driver.',
    rating: 5
  }
];




























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







// const jsonData = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Sedan Cabs Booking in Pune - Sanavi Travels",
//   "description": "Sanavi Travels offers sedan cabs on rent in Pune for airport transfers, railway station pickups, weddings, corporate travel, outstation trips, local sightseeing, and family trips. AC and Non-AC sedan cabs are available with professional drivers at affordable rates.",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.7",
//     "ratingCount": "10000+"
//   }
// };




const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/Sedan-Cabs-Booking-in-Pune#service",

  "name": "Sedan Cabs Booking in Pune",

  "serviceType": "Sedan Taxi Service",

  "description":
    "Sanavi Travels provides sedan cab booking in Pune for airport transfers, local travel, corporate trips, outstation journeys and comfortable point-to-point transportation with professional drivers.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune",
    "containedInPlace": {
      "@type": "State",
      "name": "Maharashtra",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },

  "url":
    "https://www.sanavitravels.com/Sedan-Cabs-Booking-in-Pune"
};





  return (
    <div>


<Helmet>
  <title>
    Sedan Cabs Booking in Pune | Affordable Taxi Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book sedan cabs in Pune with Sanavi Travels for airport transfers, local travel, corporate trips and outstation journeys. Comfortable cars with professional drivers at affordable rates."
  />

  <meta
    name="keywords"
    content="Sedan Cabs Booking in Pune, Sedan Taxi Pune, Cab Service Pune, Dzire Cab Pune, Etios Cab Pune, Affordable Taxi Pune, Pune Airport Sedan Cab, Outstation Sedan Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/Sedan-Cabs-Booking-in-Pune"
  />

  {/* Open Graph */}
  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="Sedan Cabs Booking in Pune | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Book affordable sedan cabs in Pune for airport transfers, local travel, corporate trips and outstation journeys with Sanavi Travels."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/Sedan-Cabs-Booking-in-Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


{/* <Helmet>
  <title>
    Sedan Cabs Booking in Pune | Affordable Taxi Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book sedan cabs in Pune for airport transfers, local travel, corporate trips and outstation rides. Comfortable and affordable taxi service with professional drivers."
  />

  <meta
    name="keywords"
    content="Sedan Cabs Booking in Pune, Sedan Taxi Pune, Cab Service Pune, Dzire Cab Pune, Etios Cab Pune, Affordable Taxi Pune, Pune Airport Sedan Cab, Outstation Sedan Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/sedan-cabs-booking-in-pune"
  />

  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Sedan Cabs Booking in Pune | Sanavi Travels"
  />
  <meta
    property="og:description"
    content="Affordable sedan cab booking in Pune for airport, local travel, corporate trips and outstation journeys."
  />
  <meta
    property="og:url"
    content="https://www.sanavitravels.com/sedan-cabs-booking-in-pune"
  />

  
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Sedan Cabs Booking in Pune",
      "serviceType": "Sedan Taxi Service",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Sanavi Travels",
        "telephone": "+91 7387507373"
      },
      "areaServed": {
        "@type": "City",
        "name": "Pune"
      },
      "description":
        "Sedan cab booking service in Pune for airport transfers, local travel, corporate rides and outstation trips at affordable rates.",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": 4.7,
        "bestRating": 5,
        "worstRating": 1,
        "ratingCount": 10000
      }
    })}
  </script>
</Helmet> */}

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/sedan-cabs-booking-in-pune.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sedancabsbookinginpune;